module.exports = __webpack_public_path__ + "1192ad6d70.woff2";